module.exports = __webpack_public_path__ + "img/left_worm_n1_2.prt.42e78bd4.jpg";